module.exports = __webpack_public_path__ + "static/media/layout9-img.f96e6305.png";